import {
  KOREAN_CURRENCY,
  KOREAN_CURRENCY_SYMBOL,
  RTL_LANGUAGES
} from 'constants/common';
import { SaudiRiyalIcon } from 'components/pcc-components';

export const removeDecimalsForWonCurrency = (amount) => {
  const lastIndexPosition = amount.lastIndexOf('.');
  const currencyData = amount[amount.length - 1];
  const amountWithoutDecimals = amount.slice(0, lastIndexPosition);
  if (lastIndexPosition === -1) {
    return amount;
  }
  if (amountWithoutDecimals.includes(currencyData)) {
    return amountWithoutDecimals;
  }
  return amountWithoutDecimals + currencyData;
};

export const checkIsNotWON = (price, currency = '') => {
  return currency
    ? shouldAddCurrencyInPrice(currency)
    : !price?.toString()?.includes(KOREAN_CURRENCY_SYMBOL);
};

export const shouldAddCurrencyInPrice = (currency) =>
  currency !== KOREAN_CURRENCY;

export const checkIsRiyal = (currency = '') => {
  if (currency == 'SAR') {
    return true;
  } else {
    return false;
  }
};

export const isRTLLang = (lang) => RTL_LANGUAGES.includes(lang);

export const getRiyalFormattedPrice = ({
  price = '',
  priceWrapperClasses = null,
  isRTL = false,
  size = 'md'
} = {}) => {
  const priceValue = price.trim();
  if (priceValue) {
    return (
      <span dir="ltr" className={isRTL ? 'text-end' : ''}>
        <span className="align-text-bottom">
          <SaudiRiyalIcon size={size} />
        </span>
        <span className={priceWrapperClasses}>{priceValue}</span>
      </span>
    );
  }
};
